export default __webpack_public_path__ + "static/media/Splash_Left.09bc42f7.gif";